"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuerySourceCachePolicyDereferenceWrapper = void 0;
class QuerySourceCachePolicyDereferenceWrapper {
    cachePolicy;
    constructor(cachePolicy) {
        this.cachePolicy = cachePolicy;
    }
    storable() {
        return this.cachePolicy.storable();
    }
    async satisfiesWithoutRevalidation(action) {
        return this.cachePolicy.satisfiesWithoutRevalidation({ url: action.link.url, context: action.context });
    }
    responseHeaders() {
        return this.cachePolicy.responseHeaders();
    }
    timeToLive() {
        return this.cachePolicy.timeToLive();
    }
    async revalidationHeaders(newAction) {
        return this.cachePolicy.revalidationHeaders({ url: newAction.link.url, context: newAction.context });
    }
    async revalidatedPolicy(revalidationAction, revalidationResponse) {
        const revalidatedPolicy = await this.cachePolicy.revalidatedPolicy({ url: revalidationAction.link.url, context: revalidationAction.context }, revalidationResponse);
        return {
            policy: new QuerySourceCachePolicyDereferenceWrapper(revalidatedPolicy.policy),
            modified: revalidatedPolicy.modified,
            matches: revalidatedPolicy.matches,
        };
    }
}
exports.QuerySourceCachePolicyDereferenceWrapper = QuerySourceCachePolicyDereferenceWrapper;
//# sourceMappingURL=QuerySourceCachePolicyDereferenceWrapper.js.map